import lodash from "lodash";
import api from "../routes/api";
import * as XLSX from "xlsx";
import { nameInputFieldPassenger, passengerField } from "../consts/consts";
import { v4 as uuidv4 } from "uuid";
import { getDownloadURL } from "firebase/storage";
import { firebaseGetFileUrl } from "../services/firebase";

export const fetchAuthPost = async (url, body = {}) => {
  try {
    const token = localStorage.getItem("token") || "";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        token,
      },
      body: JSON.stringify(body),
      credentials: "include",
    }).then((r) => r.json());
    if (response.auth) {
      return response;
    } else {
      localStorage.clear();
      window.location.replace("/");
    }
  } catch (error) {
    console.error(error);
    localStorage.clear();
    window.location.replace("/");
  }
};

export const fetchPost = async (url, token = "", body = {}) =>
  await fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token,
    },
    body: JSON.stringify(body),
  }).then((r) => r.json());

export const setStaticData = async () => {
  try {
    const [
      genderList,
      countryList,
      nationalityList,
      allProvinceDistrictSubdistrictList,
      tourTypeList,
      tripDurationList,
      readOrganization,
    ] = await Promise.all([
      fetchAuthPost(api.setting.readGenderList),
      fetchAuthPost(api.address.readCountryList),
      fetchAuthPost(api.address.readNationalityList),
      fetchAuthPost(api.address.readAllProvinceDistrictSubdistrict),
      fetchAuthPost(api.setting.readTourTypeList),
      fetchAuthPost(api.setting.readTripDurationList),
      fetchAuthPost(api.setting.readOrganization),
    ]);
    localStorage.setItem(
      "ltdName",
      readOrganization?.data?.company?.company_name_english
    );

    // const genderList = [
    //   {
    //     id_gender: 1,
    //     gender: "male",
    //     gender_th: null,
    //     gender_en: null,
    //   },
    //   {
    //     id_gender: 2,
    //     gender: "female",
    //     gender_th: null,
    //     gender_en: null,
    //   },
    // ];
    // const tourTypeList = [
    //   {
    //     id_tour_type: 1,
    //     tour_type: "join",
    //   },
    //   {
    //     id_tour_type: 2,
    //     tour_type: "private",
    //   },
    // ];
    // const tripDurationList = [
    //   {
    //     id_trip_duration: 1,
    //     name: "day_trip",
    //     trip_duration: "Day Trip",
    //   },
    //   {
    //     id_trip_duration: 2,
    //     name: "overnight",
    //     trip_duration: "Overnight",
    //   },
    // ];
    const result = {
      genderList: genderList?.data || genderList,
      countryList: countryList?.data,
      nationalityList: nationalityList?.data,
      allProvinceDistrictSubdistrictList:
        allProvinceDistrictSubdistrictList?.data,
      tourTypeList: tourTypeList?.data || tourTypeList,
      tripDurationList: tripDurationList?.data || tripDurationList,
      staticDataStatus: true,
    };
    localStorage.setItem("staticData", JSON.stringify(result));
    return result;
  } catch (error) {
    console.error(error);
    window.location.replace("/");
    return null;
  }
};

export const timeToYYYYMMDD = (time) => {
  const t = new Date(time);
  const yyyy = t.getFullYear();
  let mm = t.getMonth() + 1;
  if (mm < 10) mm = `0${mm}`;
  let dd = t.getDate();
  if (dd < 10) dd = `0${dd}`;
  return `${yyyy}-${mm}-${dd}`;
};

export const timeToYYYYMM = (time) => {
  const t = new Date(time);
  const yyyy = t.getFullYear();
  let mm = t.getMonth() + 1;
  if (mm < 10) mm = `0${mm}`;
  return `${yyyy}-${mm}`;
};

export const yyyymmddd_ddmmyyyy_v1 = (yyyymmdd) => {
  if (!yyyymmdd) return;
  const [yyyy, mm, dd] = yyyymmdd.split("-");
  return `${dd}/${mm}/${yyyy}`;
};

export const reduceRepeatElement = (arr, key) => {
  return lodash.uniqBy(arr, key);
};

export const calculateAge = (birthDate) => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

export const calculateAgeGroup = (age, adult_age, child_age, infant_age) => {
  let ageGroup;
  const temp_age = +age;
  if (temp_age >= adult_age) {
    ageGroup = "adult";
  } else if (temp_age > infant_age) {
    ageGroup = "child";
  } else {
    ageGroup = "infant";
  }
  return ageGroup;
};

export const generateDateYYYYMMDDList = (yyyymmdd_start, yyyymmdd_end) => {
  const start = new Date(yyyymmdd_start).getTime();
  const end = new Date(yyyymmdd_end).getTime();
  const diff = end - start;
  const n = diff / (1000 * 24 * 60 * 60) + 1;
  const dateList = [];
  let temp = start;
  for (let i = 0; dateList.length < n; i++) {
    dateList.push(timeToYYYYMMDD(temp));
    temp += 1000 * 24 * 60 * 60 * 1;
  }
  return dateList;
};

export const convertReportToTableCustomerListReport = (data) => {
  // const data = [
  //   {
  //     agent: null,
  //     firstname: "fa1",
  //     lastname: "la1",
  //     id_gender: 1,
  //     age: 20,
  //     id_passport_no: "123",
  //     id_country: 204,
  //     id_nationality: 165,
  //     boat: "boat 1",
  //     team: "team 1",
  //     voucher_no: "VCH-001",
  //     hotel_address: "hotel",
  //     age: 20,
  //     id_passenger: 33,
  //     group_id: 24,
  //     checkin_no: "A123",
  //     age_group: "adult",
  //     signature_base64: "",
  //     signature_image_filepath: "",
  //   },
  // ];
  const staticData = JSON.parse(localStorage.getItem("staticData"));
  const { genderList, nationalityList, countryList } = staticData;
  const temp = data.map((el) => ({
    ...el,
    gender: genderList.find((el2) => +el2.id_gender === +el.id_gender)?.gender,
  }));
  const id_tour_group_list = reduceRepeatElement(temp, "id_tour_group").map(
    (el) => +el.id_tour_group
  );
  const temp_row = [];
  for (let i = 0; i < id_tour_group_list.length; i++) {
    const id_tour_group = id_tour_group_list[i];
    const temp_passenger = temp.filter(
      (el) => +el.id_tour_group === +id_tour_group
    );
    let checkin_no_list = temp_passenger.map((el) => el.checkin_no);
    checkin_no_list = [...new Set(checkin_no_list)];
    checkin_no_list = checkin_no_list.sort();
    checkin_no_list = sortCheckinNoList(checkin_no_list);
    for (let j = 0; j < checkin_no_list.length; j++) {
      const checkin_no = checkin_no_list[j];
      const temp_passenger_2 = temp_passenger
        .filter((el) => el.checkin_no === checkin_no)
        .sort((el) => el.firstname);
      const num_of_adult = temp_passenger_2.filter(
        (el) => el.age_group === "adult"
      ).length;
      const num_of_child = temp_passenger_2.filter(
        (el) => el.age_group === "child"
      ).length;
      const num_of_infant = temp_passenger_2.filter(
        (el) => el.age_group === "infant"
      ).length;
      let isFirstOfGroupOfCheckinNo = true;
      for (let k = 0; k < temp_passenger_2.length; k++) {
        const passenger = temp_passenger_2[k];
        const row = {
          agent: passenger.agent || "F.I.T.",
          firstname: passenger.firstname,
          lastname: passenger.lastname,
          gender: passenger.gender,
          age: passenger.age,
          id_passport_no: passenger.id_passport_no,
          country: countryList.find(
            (el) => +el.id_country === +passenger.id_country
          )?.label_en,
          nationality: nationalityList.find(
            (el) => +el.id_nationality === +passenger.id_nationality
          )?.label_en,
          boat: passenger.boat,
          team: passenger.team,
          adl: isFirstOfGroupOfCheckinNo ? `${num_of_adult}` : "-",
          chd: isFirstOfGroupOfCheckinNo ? `${num_of_child}` : "-",
          ift: isFirstOfGroupOfCheckinNo ? `${num_of_infant}` : "-",
          voucher_no: passenger.voucher_no || "-",
          hotel: passenger.hotel_address || "-",
          group_id: passenger.group_id,
          checkin_no: passenger.checkin_no,
          signature: passenger.signature_base64,
        };
        isFirstOfGroupOfCheckinNo = false;
        temp_row.push(row);
      }
      // const rowsPromises = temp_passenger_2.map(async (passenger, index) => {
      //   const signature_image_url = await firebaseGetFileUrl({
      //     filePath: passenger.signature_image_filepath,
      //   });
      //   const row = {
      //     agent: passenger.agent || "F.I.T.",
      //     firstname: passenger.firstname,
      //     lastname: passenger.lastname,
      //     gender: passenger.gender,
      //     age: passenger.age,
      //     id_passport_no: passenger.id_passport_no,
      //     country: countryList.find(
      //       (el) => +el.id_country === +passenger.id_country
      //     )?.label_en,
      //     nationality: nationalityList.find(
      //       (el) => +el.id_nationality === +passenger.id_nationality
      //     )?.label_en,
      //     boat: passenger.boat,
      //     team: passenger.team,
      //     // adl: isFirstOfGroupOfCheckinNo ? `${num_of_adult}` : "-",
      //     // chd: isFirstOfGroupOfCheckinNo ? `${num_of_child}` : "-",
      //     // ift: isFirstOfGroupOfCheckinNo ? `${num_of_infant}` : "-",
      //     adl: index === 0 ? `${num_of_adult}` : "-",
      //     chd: index === 0 ? `${num_of_child}` : "-",
      //     ift: index === 0 ? `${num_of_infant}` : "-",
      //     voucher_no: passenger.voucher_no || "-",
      //     hotel: passenger.hotel_address || "-",
      //     group_id: passenger.group_id,
      //     checkin_no: passenger.checkin_no,
      //     signature: signature_image_url,
      //     signature_image_filepath: passenger.signature_image_filepath,
      //   };

      //   // isFirstOfGroupOfCheckinNo = false;
      //   return row;
      // });
      // const rows = await Promise.all(rowsPromises);
      // temp_row.push(...rows);
    }
  }
  return temp_row.map((el, index) => ({ ...el, no: index + 1 }));
};
export const convertReportToTableRegister = (data) => {
  // const data = [
  //   {
  //     agent: null,
  //     firstname: "fa1",
  //     lastname: "la1",
  //     id_gender: 1,
  //     id_passport_no: "123",
  //     id_country: 204,
  //     id_nationality: 165,
  //     voucher_no: "VCH-001",
  //     hotel_address: "hotel",
  //     age: 20,
  //     group_id: 24,
  //     id_passenger: 33,
  //     age_group: "adult",
  //     signature_base64: "",
  //     checkin_no: "",
  //     signature_image_filepath: "",
  //   },
  // ];
  const staticData = JSON.parse(localStorage.getItem("staticData"));
  const { genderList } = staticData;
  const temp = data.map((el) => ({
    ...el,
    gender: genderList.find((el2) => +el2.id_gender === +el.id_gender)?.gender,
  }));
  const id_tour_group_list = reduceRepeatElement(temp, "id_tour_group").map(
    (el) => +el.id_tour_group
  );
  const temp_row = [];
  for (let i = 0; i < id_tour_group_list.length; i++) {
    const id_tour_group = id_tour_group_list[i];
    const temp_passenger = temp.filter(
      (el) => +el.id_tour_group === +id_tour_group
    );
    let checkin_no_list = temp_passenger.map((el) => el.checkin_no);
    checkin_no_list = [...new Set(checkin_no_list)];
    checkin_no_list = checkin_no_list.sort();
    checkin_no_list = sortCheckinNoList(checkin_no_list);
    for (let j = 0; j < checkin_no_list.length; j++) {
      const checkin_no = checkin_no_list[j];
      const temp_passenger_2 = temp_passenger
        .filter((el) => el.checkin_no === checkin_no)
        .sort((el) => el.firstname);
      const num_of_adult = temp_passenger_2.filter(
        (el) => el.age_group === "adult"
      ).length;
      const num_of_child = temp_passenger_2.filter(
        (el) => el.age_group === "child"
      ).length;
      const num_of_infant = temp_passenger_2.filter(
        (el) => el.age_group === "infant"
      ).length;
      let isFirstOfGroupOfCheckinNo = true;
      for (let k = 0; k < temp_passenger_2.length; k++) {
        const passenger = temp_passenger_2[k];
        const row = {
          firstname: passenger.firstname,
          lastname: passenger.lastname,
          gender: passenger.gender,
          age: passenger.age,
          adl: isFirstOfGroupOfCheckinNo ? `${num_of_adult}` : "",
          chd: isFirstOfGroupOfCheckinNo ? `${num_of_child}` : "",
          ift: isFirstOfGroupOfCheckinNo ? `${num_of_infant}` : "",
          agent: passenger.agent || "F.I.T.",
          group_id: passenger.group_id,
          checkin_no: passenger.checkin_no,
          signature: passenger.signature_base64,
        };
        isFirstOfGroupOfCheckinNo = false;
        temp_row.push(row);
      }
      // const rowsPromises = temp_passenger_2.map(async (passenger, index) => {
      //   const signature_image_url = await firebaseGetFileUrl({
      //     filePath: passenger.signature_image_filepath,
      //   });
      //   const row = {
      //     firstname: passenger.firstname,
      //     lastname: passenger.lastname,
      //     gender: passenger.gender,
      //     age: passenger.age,
      //     // adl: isFirstOfGroupOfCheckinNo ? `${num_of_adult}` : "",
      //     // chd: isFirstOfGroupOfCheckinNo ? `${num_of_child}` : "",
      //     // ift: isFirstOfGroupOfCheckinNo ? `${num_of_infant}` : "",
      //     adl: index === 0 ? `${num_of_adult}` : "",
      //     chd: index === 0 ? `${num_of_child}` : "",
      //     ift: index === 0 ? `${num_of_infant}` : "",
      //     agent: passenger.agent || "F.I.T.",
      //     group_id: passenger.group_id,
      //     checkin_no: passenger.checkin_no,
      //     signature: signature_image_url,
      //     signature_image_filepath: passenger.signature_image_filepath,
      //   };
      //   return row;
      // });
      // const rows = await Promise.all(rowsPromises);
      // temp_row.push(...rows);
    }
  }
  return temp_row.map((el, index) => ({ ...el, no: index + 1 }));
};

export const convertReportToTableInsuracneReport = (data) => {
  // const data = [
  //   {
  //     agent: null,
  //     firstname: "fa1",
  //     lastname: "la1",
  //     id_gender: 1,
  //     id_passport_no: "123",
  //     id_country: 165,
  //     id_nationality: 165,
  //     voucher_no: "VCH-001",
  //     hotel_address: "hotel",
  //     age: 20,
  //     group_id: 24,
  //     id_passenger: 33,
  //     age_group: "adult",
  //     signature_base64: "",
  //     checkin_no: "",
  //     signature_image_filepath: "",
  //   },
  // ];
  const staticData = JSON.parse(localStorage.getItem("staticData"));
  const { genderList } = staticData;
  const temp = data.map((el) => ({
    ...el,
    gender: genderList.find((el2) => +el2.id_gender === +el.id_gender)?.gender,
  }));
  const id_tour_group_list = reduceRepeatElement(temp, "id_tour_group").map(
    (el) => +el.id_tour_group
  );
  const temp_row = [];
  for (let i = 0; i < id_tour_group_list.length; i++) {
    const id_tour_group = id_tour_group_list[i];
    const temp_passenger = temp.filter(
      (el) => +el.id_tour_group === +id_tour_group
    );
    let checkin_no_list = temp_passenger.map((el) => el.checkin_no);
    checkin_no_list = [...new Set(checkin_no_list)];
    checkin_no_list = checkin_no_list.sort();
    checkin_no_list = sortCheckinNoList(checkin_no_list);
    for (let j = 0; j < checkin_no_list.length; j++) {
      const checkin_no = checkin_no_list[j];
      const temp_passenger_2 = temp_passenger
        .filter((el) => el.checkin_no === checkin_no)
        .sort((el) => el.firstname);
      const num_of_adult = temp_passenger_2.filter(
        (el) => el.age_group === "adult"
      ).length;
      const num_of_child = temp_passenger_2.filter(
        (el) => el.age_group === "child"
      ).length;
      const num_of_infant = temp_passenger_2.filter(
        (el) => el.age_group === "infant"
      ).length;
      let isFirstOfGroupOfCheckinNo = true;
      for (let k = 0; k < temp_passenger_2.length; k++) {
        const passenger = temp_passenger_2[k];
        const row = {
          firstname: passenger.firstname,
          lastname: passenger.lastname,
          gender: passenger.gender,
          age: passenger.age,
          adl: isFirstOfGroupOfCheckinNo ? `${num_of_adult}` : "",
          chd: isFirstOfGroupOfCheckinNo ? `${num_of_child}` : "",
          ift: isFirstOfGroupOfCheckinNo ? `${num_of_infant}` : "",
          checkin_no: passenger.checkin_no,
          signature: passenger.signature_base64,
        };
        isFirstOfGroupOfCheckinNo = false;
        temp_row.push(row);
      }
      // const rowsPromises = temp_passenger_2.map(async (passenger, index) => {
      //   const signature_image_url = await firebaseGetFileUrl({
      //     filePath: passenger.signature_image_filepath,
      //   });
      //   const row = {
      //     firstname: passenger.firstname,
      //     lastname: passenger.lastname,
      //     gender: passenger.gender,
      //     age: passenger.age,
      //     adl: index === 0 ? `${num_of_adult}` : "",
      //     chd: index === 0 ? `${num_of_child}` : "",
      //     ift: index === 0 ? `${num_of_infant}` : "",
      //     checkin_no: passenger.checkin_no,
      //     signature: signature_image_url,
      //     signature_image_filepath: passenger.signature_image_filepath,
      //   };
      //   return row;
      // });
      // const rows = await Promise.all(rowsPromises);
      // temp_row.push(...rows);
    }
  }
  return temp_row.map((el, index) => ({ ...el, no: index + 1 }));
};

export const importPassengerExcelToObject = (fileFromInput) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      let object = XLSX.utils.sheet_to_json(worksheet, {
        range: 4,
      });
      object = object.filter((el) => el["No."]);
      object = object.splice(1);
      resolve(object);
    };
    reader.onerror = (err) => reject(err);
    reader.readAsArrayBuffer(fileFromInput);
  });
};

export const validatePassengerObject = (object) => {
  const notPassList = [];
  for (let i = 0; i < object.length; i++) {
    const el = object[i];
    const no = el["No."];
    const firstname = el?.["First Name"];
    const lastname = el?.["Last Name"];
    const gender = el?.["Gender"];
    const date_of_birth = el?.["Date of Birth"];
    const country = el?.["Country"];
    const nationality = el?.["Nationality"];
    const id_passport_no = el?.["ID/Passport No."];
    const hotel_address = el?.["Hotel/Adderss"];
    const checkin_no = el?.["Checkin No."];
    const isPass =
      firstname &&
      lastname &&
      gender &&
      date_of_birth &&
      country &&
      nationality &&
      id_passport_no &&
      hotel_address &&
      checkin_no;
    if (!isPass) {
      notPassList.push(no);
    }
  }
  return notPassList;
};

// 13/12/2000 --> 2000-12-13
export const convert_ddmmyyyy_to_yyyymmdd_v1 = (ddmmyyyy) => {
  if (!ddmmyyyy) return;
  let [dd, mm, yyyy] = ddmmyyyy.split("/");
  if (+dd < 10) {
    dd = `0${+dd}`;
  }
  if (+mm < 10) {
    mm = `0${+mm}`;
  }
  const yyyymmdd = `${yyyy}-${mm}-${dd}`;
  return yyyymmdd;
};

export const formatPatternPassengerExcelObjectToFlatPassengerData = (
  passengerObject,
  genderOption,
  countryOption,
  nationalityOption,
  adultAge,
  childAge,
  infantAge
) => {
  let object = passengerObject;
  object = object.map((el) => ({
    no: el["No."],
    firstname: el?.["First Name"],
    lastname: el?.["Last Name"],
    gender: el?.["Gender"],
    date_of_birth: el?.["Date of Birth"],
    country: el?.["Country"],
    nationality: el?.["Nationality"],
    id_passport_no: el?.["ID/Passport No."],
    hotel_address: el?.["Hotel/Adderss"],
    voucher_no: el?.["Voucher No."],
    checkin_no: el?.["Checkin No."],
  }));
  object = object.map((el) => {
    const id_gender = genderOption.find(
      (el2) => `${el2.label}`.toLowerCase() === `${el.gender}`.toLowerCase()
    )?.value;
    const date_of_birth = convert_ddmmyyyy_to_yyyymmdd_v1(el.date_of_birth);
    const id_country = countryOption.find(
      (el2) => `${el2.label}`.toLowerCase() === `${el.country}`.toLowerCase()
    )?.value;
    const id_nationality = nationalityOption.find(
      (el2) =>
        `${el2.label}`.toLowerCase() === `${el.nationality}`.toLowerCase()
    )?.value;
    const age = +calculateAge(date_of_birth);
    const age_group = calculateAgeGroup(age, adultAge, childAge, infantAge);
    const temp = {
      firstname: el.firstname,
      lastname: el.lastname,
      id_gender,
      date_of_birth,
      na: false,
      age,
      id_country,
      id_nationality,
      id_passport_no: el.id_passport_no,
      hotel_address: el.hotel_address,
      voucher_no: el.voucher_no,
      age_group,
      checkin_no: el.checkin_no,
      fill_later: !(el.firstname && el.lastname), // ถ้ามีทั้ง firstname และ lastname พร้อมกันจะได้ fill_later = false
    };
    return temp;
  });
  return object;
};

export const generatePassengers = (
  msgAdults,
  msgChilds,
  msgInfants,
  numOfAdult,
  numOfChild,
  numOfInfant
) => {
  let tempPassengers = [];

  for (let i = 1; i <= numOfAdult; i++) {
    const ageGroup = "adult";
    const index = i - 1;
    const prefix = `passenger_list`;
    const temp = {
      ...nameInputFieldPassenger,
      title: msgAdults,
      ageGroup,
      index,
      prefix,
    };
    tempPassengers.push(temp);
  }
  for (let i = 1; i <= numOfChild; i++) {
    const ageGroup = "child";
    const index = i - 1;
    const prefix = `passenger_list`;
    const temp = {
      ...nameInputFieldPassenger,
      title: msgChilds,
      ageGroup,
      index,
      prefix,
    };
    tempPassengers.push(temp);
  }
  for (let i = 1; i <= numOfInfant; i++) {
    const ageGroup = "infant";
    const index = i - 1;
    const prefix = `passenger_list`;
    const temp = {
      ...nameInputFieldPassenger,
      title: msgInfants,
      ageGroup,
      index,
      prefix,
    };
    tempPassengers.push(temp);
  }

  tempPassengers = tempPassengers.map((el, index) => ({
    ...el,
    number: index + 1,
    selectable: true,
    isChecked: false,
    isDisabledDateOfBirth: false,
  }));

  if (numOfAdult === 1) {
    tempPassengers = tempPassengers.map((el) => ({
      ...el,
      selectable: el.ageGroup !== "adult",
    }));
  }

  return tempPassengers;
};

export const generatePassengersByPassengerList = (
  msgAdults,
  msgChilds,
  msgInfants,
  passengerList
) => {
  const adult = passengerList?.adult || [];
  const child = passengerList?.child || [];
  const infant = passengerList?.infant || [];

  const numOfAdult = adult.length;
  const numOfChild = child.length;
  const numOfInfant = infant.length;

  const passengers = generatePassengers(
    msgAdults,
    msgChilds,
    msgInfants,
    numOfAdult,
    numOfChild,
    numOfInfant
  );

  return passengers;
};

export const generatePassengersAndPassengerList = (
  msgAdults,
  msgChilds,
  msgInfants,
  numOfAdult,
  numOfChild,
  numOfInfant
) => {
  const passengers = generatePassengers(
    msgAdults,
    msgChilds,
    msgInfants,
    numOfAdult,
    numOfChild,
    numOfInfant
  );
  const adult = [];
  const child = [];
  const infant = [];
  for (let i = 0; i < passengers.length; i++) {
    const el = passengers[i];
    if (el.ageGroup === "adult") {
      adult.push({ ...passengerField, age_group: "adult" });
    } else if (el.ageGroup === "child") {
      child.push({ ...passengerField, age_group: "child" });
    } else if (el.ageGroup === "infant") {
      infant.push({ ...passengerField, age_group: "infant" });
    }
  }
  const passenger_list = { adult, child, infant };
  return [passengers, passenger_list];
};

export const generatePassengersAndPassengerListByPassengerList = (
  msgAdults,
  msgChilds,
  msgInfants,
  passengerList
) => {
  const numOfAdult = (passengerList?.adult || []).length;
  const numOfChild = (passengerList?.child || []).length;
  const numOfInfant = (passengerList?.infant || []).length;
  const passengers = generatePassengers(
    msgAdults,
    msgChilds,
    msgInfants,
    numOfAdult,
    numOfChild,
    numOfInfant
  );
  const passenger_list = passengerList;
  return [passengers, passenger_list];
};

export const joinPassengerListToPassengersAndPassengerList = (
  msgAdults,
  msgChilds,
  msgInfants,
  passenger_list_1,
  passenger_list_2
) => {
  // join form
  const passengers_1 = generatePassengersByPassengerList(
    msgAdults,
    msgChilds,
    msgInfants,
    passenger_list_1
  );
  const passengers_2 = generatePassengersByPassengerList(
    msgAdults,
    msgChilds,
    msgInfants,
    passenger_list_2
  );

  let passengers = [...passengers_1, ...passengers_2];

  let passengersAdult = passengers.filter((el) => el.ageGroup === "adult");
  let passengersChild = passengers.filter((el) => el.ageGroup === "child");
  let passengersInfant = passengers.filter((el) => el.ageGroup === "infant");

  passengersAdult = passengersAdult.map((el, index) => ({ ...el, index }));
  passengersChild = passengersChild.map((el, index) => ({ ...el, index }));
  passengersInfant = passengersInfant.map((el, index) => ({ ...el, index }));

  passengers = [...passengersAdult, ...passengersChild, ...passengersInfant];

  passengers = passengers.map((el, index) => ({
    ...el,
    number: index + 1,
    selectable: true,
  }));

  const numOfAdult = passengersAdult.length;

  if (numOfAdult === 1) {
    passengers = passengers.map((el) => ({
      ...el,
      selectable: el.ageGroup !== "adult",
    }));
  }

  // join passenger_list
  const adult_1 = passenger_list_1.adult;
  const child_1 = passenger_list_1.child;
  const infant_1 = passenger_list_1.infant;
  const adult_2 = passenger_list_2.adult;
  const child_2 = passenger_list_2.child;
  const infant_2 = passenger_list_2.infant;

  const adult = [...adult_1, ...adult_2];
  const child = [...child_1, ...child_2];
  const infant = [...infant_1, ...infant_2];

  const passenger_list = { adult, child, infant };

  // set isDisabledDateOfBirth
  passengers = passengers.map((el) => {
    const na = passenger_list[el.ageGroup][el.index].na;
    return { ...el, isDisabledDateOfBirth: na };
  });

  // set isCheckedFillLater
  passengers = passengers.map((el) => {
    const fill_later = passenger_list[el.ageGroup][el.index].fill_later;
    return { ...el, isCheckedFillLater: fill_later };
  });

  return [passengers, passenger_list];
};

export const loadFontAsBase64 = async (url) => {
  const response = await fetch(url);
  const buffer = await response.arrayBuffer();
  const base64 = btoa(
    new Uint8Array(buffer).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      ""
    )
  );
  return base64;
};

export const timestampFilename = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}${month}${day}_${hours}${minutes}${seconds}`;
};

export const base64ToUint8Array = (base64) => {
  const binary = atob(base64); // decode base64
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

export const getImageWithAspectRatio = (base64, fixedHeight = 40) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      const aspectRatio = img.width / img.height;
      const width = fixedHeight * aspectRatio;
      resolve({ image: base64, width, height: fixedHeight });
    };
    img.src = base64;
  });
};

export const getImageDimensions = (base64) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = reject;
    img.src = "data:image/jpeg;base64," + base64;
  });

/**
 * Sort checkin numbers:
 * 1. ตัวเลขล้วน → ขึ้นก่อน
 * 2. ตัวอักษรล้วน → ตามตัวอักษร
 * 3. ตัวผสมเลข+อักษร → ตามตัวอักษรและตัวเลข
 */
export const sortCheckinNoList = (checkin_no_list) => {
  return checkin_no_list.sort((a, b) => {
    const rank = (val) => {
      if (/^\d+$/.test(val)) return 0; // ตัวเลขล้วน
      if (/^[A-Za-z]+$/.test(val)) return 1; // ตัวอักษรล้วน
      return 2; // ผสมตัวเลข+ตัวอักษร
    };

    const rankA = rank(a);
    const rankB = rank(b);

    if (rankA !== rankB) return rankA - rankB;

    // ในแต่ละกลุ่ม sort
    if (rankA === 0) return parseInt(a) - parseInt(b); // ตัวเลขล้วน
    if (rankA === 1) return a.localeCompare(b); // ตัวอักษรล้วน
    if (rankA === 2) {
      // แยกตัวอักษรและตัวเลขออกมา
      const partsA = a.match(/[A-Za-z]+|\d+/g) || [];
      const partsB = b.match(/[A-Za-z]+|\d+/g) || [];
      for (let i = 0; i < Math.min(partsA.length, partsB.length); i++) {
        if (partsA[i] !== partsB[i]) {
          if (/^\d+$/.test(partsA[i]) && /^\d+$/.test(partsB[i])) {
            return parseInt(partsA[i]) - parseInt(partsB[i]);
          } else {
            return partsA[i].localeCompare(partsB[i]);
          }
        }
      }
      return partsA.length - partsB.length;
    }
    return 0;
  });
};

export const hhmm_to_number_sec = (hhmm) => {
  let [hh, mm] = hhmm.split(":");
  hh = +hh;
  mm = +mm;
  const hh_sec = hh * 60 * 60; // sec
  const mm_sec = mm * 60; // sec
  const result = hh_sec + mm_sec; // sec
  return result;
};

export const enRatio = (a1, a2, b1, b2) => {
  const ca = (a1 + a2) / 2;
  const cb = (b1 + b2) / 2;
  const ra = (Math.max(a1, a2) - Math.min(a1, a2)) / 2;
  const rb = (Math.max(b1, b2) - Math.min(b1, b2)) / 2;
  const d = Math.abs(ca - cb);
  if (d === 0.0) {
    return 0.0;
  } else if (ra === 0.0 && rb === 0.0) {
    return NaN;
  }
  const en = d / (ra + rb);
  return en;
};

export const getUUID = () => {
  return uuidv4().toLowerCase();
};

export const checkImageDataType = ({ src }) => {
  if (!src) return null;
  if (/^https?:\/\//i.test(src)) return "url";
  if (/^data:image\/[a-z]+;base64,/.test(src)) return "base64";
  return "unknown";
};

export const imageUrlToBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result); // จะได้ string เช่น "data:image/png;base64,..."
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
